import { useState } from "react";
import InvoiceDataList from "./invoice-data-lists";

const InvoiceDetails = (props: any) => {
  const [myOrderData] = useState<any>(props.orderData);
  
  return (
    <>
      {props.orderInvoice.length > 0 ? (
        <InvoiceDataList invoiceData={props.orderInvoice} orderData={myOrderData} />
      ) : null}
    </>
  );
};

export default InvoiceDetails;
